import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Avatar,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IMAGE_URL } from "../../services/api";
import ProtectedImage from "../../components/ProtectedImage";

// const BASE_URL = "http://localhost:8000";

const ReviewersDetailModal = ({ open, handleClose, reviewers, anchorEl }) => {
  if (!anchorEl) return null; // anchorEl is the main modal container

  const rect = anchorEl.getBoundingClientRect();

  const hasReviews = reviewers && reviewers.length > 0;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      hideBackdrop
      PaperProps={{
        sx: {
          position: "absolute",
          top: `${rect.top}px`,
          left: `${rect.left + rect.width / 2}px`,
          height: `${rect.height}px`,
          width: `${rect.width / 2}px`,
          maxWidth: "none",
          margin: 0,
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", p: 2 }}>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Reviewers Details
        </Typography>
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 2 }}>
        {!hasReviews ? (
          <Typography variant="body2" color="text.secondary">
            No reviews for this appraisal
          </Typography>
        ) : (
          reviewers.map((rev, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                mb: 2,
              }}
            >
              {/* Top Row: Image + Name + ID + Active dot */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <ProtectedImage
  path={
    rev.profile_image
      ? rev.profile_image.startsWith("data:")
        ? rev.profile_image // already a base64 data URI
        : `${IMAGE_URL}${rev.profile_image}` // protected URL
      : null
  }
  alt={rev.employee_name || "Profile Image"}
  className="employee-avatar"
  style={{
    width: 56,
    height: 56,
    borderRadius: "50%",       // to mimic Avatar's round shape
    objectFit: "cover",        // crop/cover similar to Avatar
    backgroundColor: "#ccc",   // fallback background
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 24,
    fontWeight: 600
  }}
>
  {/* Fallback initial if no image */}
  {!rev.profile_image && rev.employee_name?.[0]?.toUpperCase()}
</ProtectedImage>

                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {rev.employee_name}
                    </Typography>
                    {rev.employee_id && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                      >
                        ({rev.employee_id})
                      </Typography>
                    )}
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: rev.is_active ? "#00cc00" : "red",
                      }}
                    />
                  </Box>

                  {rev.designation && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 0.2 }}
                    >
                      {rev.designation}
                    </Typography>
                  )}
                </Box>
              </Box>

              {/* Review Info */}
              <Box sx={{ pl: 0.5 }}>
                <Typography variant="body2">
                  <strong>Rating:</strong> {rev.rating || "N/A"}
                </Typography>
                <Typography variant="body2">
                  <strong>Date:</strong> {rev.review_date || "N/A"}
                </Typography>
                <Typography variant="body2">
                  <strong>Comments:</strong> {rev.comments || "No comments"}
                </Typography>
              </Box>

              {index !== reviewers.length - 1 && <Divider />}
            </Box>
          ))
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReviewersDetailModal;
 